import { Component, Injector, OnInit } from '@angular/core';
import { ApBaseModalComponent } from 'webcommon/core-ui';
import { ApColorSelectorService } from './ap-color-selector.service';
import { ColorPaletteDto } from 'webcommon/shared';
import { ColorPalette } from './ap-color-palette.const';

@Component({
  selector: 'ap-color-selector',
  templateUrl: './ap-color-selector.component.html',
  styleUrls: ['./ap-color-selector.component.less']
})
export class ApColorSelectorComponent extends ApBaseModalComponent<boolean> implements OnInit {
  public baseId: string;
  public Id: string;
  public colors: ColorPaletteDto[] = [];
  public colorCode: string;
  public selectedColor: ColorPaletteDto = {
    name: '',
    hexCode: ''
  };
  public isSaving = false;

  constructor(
    elementInjector: Injector,
    private apColorSelectorService: ApColorSelectorService
  ) {
    super(elementInjector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.colors = ColorPalette;

    this.preselectColor();
  }

  public noSelected(): void {
    super.closeModal(false);
  }

  public selectColor(color: ColorPaletteDto): void {
    this.selectedColor = color;
    this.isSaving = true;
  }

  public saveColor(): void {
    this.apColorSelectorService.setAppliedColor(this.selectedColor.hexCode);
    super.closeModal(true);
  }

  public preselectColor(): void {
    this.selectedColor.hexCode = this.colorCode;
    const foundColor = this.colors.find(color => color.hexCode === this.colorCode);
    if (foundColor) {
      this.selectedColor.name = foundColor.name;
    }
  }
}
